import React, { type FC, useEffect } from 'react'
import ReactFlagsSelect from 'react-flags-select'
import '../../../assets/App.css'
import '../../../assets/Mobile.css'
import { useTranslation } from 'react-i18next'
import { storeLanguage } from '../../../utils/languageStore'
import { defaultLanguage, type Language } from '../../../constants/lang'

const LanguageSelector: FC = () => {
  const { i18n } = useTranslation()
  const language: Language = asLanguage(i18n.language)
  const changeLanguage = i18n.changeLanguage.bind(this)

  const onSelectLanguage = (country: string): void => {
    const la = getLanguage(country)
    changeLanguage(la).catch((e: unknown) => {
      console.warn('Language changing failed on error:', e)
    })
  }

  useEffect(() => {
    storeLanguage(language ?? defaultLanguage)
  }, [language])

  return (
        <ReactFlagsSelect
            countries={['FI']}
            placeholder={language}
            onSelect={onSelectLanguage}
            selected={language}
            showOptionLabel={false}
            showSelectedLabel={false}
            className={'language-selector'}
            selectButtonClassName={'language-select-button'}
        />
  )
}

export default LanguageSelector

/* Helper Functions */

function getLanguage(country: string): Language {
  switch (country) {
    case 'FI':
      return 'fi'
    default:
      return defaultLanguage
  }
}

function asLanguage(lang: string): Language {
  switch (lang) {
    case 'fi':
      return lang
    case 'en':
      return lang
    default:
      return defaultLanguage
  }
}
